import script from "./NotesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NotesComponent.vue?vue&type=script&setup=true&lang=js"

import "./NotesComponent.vue?vue&type=style&index=0&id=e5a4cacc&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5a4cacc"]])

export default __exports__